var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { connect } from "react-redux";
import { IdAnimDog, ListDogAnimation } from "../../graphics/IdAnimDog";
import { StateBuildingGraphics } from "../../graphics/StateBuildingGraphics";
import { IdStyles } from "../../less/IdStyles";
import { IdEventSoundCore } from "../../utils/sound/IdEventSoundCore";
import { utilSound } from "../../utils/sound/utilSound";
import { dogTreatCanvas } from "./DogTreatCanvas";
var DogCurrentStateDOM = /** @class */ (function (_super) {
    __extends(DogCurrentStateDOM, _super);
    function DogCurrentStateDOM() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DogCurrentStateDOM.prototype.componentDidMount = function () {
        dogTreatCanvas.start();
        setTimeout(function () {
            var dog = dogTreatCanvas.getDog();
            utilSound.event(IdEventSoundCore.DogIdlePlayful);
            dog.animateRandomDogState(ListDogAnimation.Interactive, function () {
                dog.playRandomAnimations();
            });
        }, 0);
    };
    DogCurrentStateDOM.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.isDogReceiving) {
            var dog_1 = dogTreatCanvas.getDog();
            dog_1.updateState(StateBuildingGraphics.Idle, IdAnimDog.Sniff, true, function () {
                dog_1.playRandomAnimations();
            });
        }
    };
    DogCurrentStateDOM.prototype.componentWillUnmount = function () {
        dogTreatCanvas.destroy();
    };
    DogCurrentStateDOM.prototype.render = function () {
        return (React.createElement("div", { className: IdStyles.DogGraphicContainer, id: "dog-treat-canvas-container" },
            React.createElement("canvas", { id: "dog-treat-canvas" })));
    };
    return DogCurrentStateDOM;
}(React.Component));
var mapState = function (state) { return ({
    isDogReceiving: state.doghouse.cooldownTime !== 0,
}); };
export var DogCurrentState = connect(mapState)(DogCurrentStateDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/doghouse/DogCurrentState.tsx
// module id = 922
// module chunks = 3